<div class="search-field">
  <span class="search-icon"></span>
  <input
     [formControl]="searchText"
     [placeholder]="placeholder"
     />
</div>
